// extracted by mini-css-extract-plugin
export default {"SidePanel":"side-panel-module--SidePanel--Ao3BC","Header":"side-panel-module--Header--tR3jH"};